import React, { Component } from 'react';
import { Col, FormGroup, Input, InputGroupAddon, InputGroupText, Label, Row } from 'reactstrap';
import { connect } from 'react-redux';
import util from '../lib/utils';
import minus from '../Res/Icon/minus.png';
import plus from '../Res/Icon/plus.png';
import CompanyAutocomplete from './CompanyAutocomplete';
import MultiInput from './MultiInput';
import LocationDetails from './LocationDetails';
import Toggle from './Toggle';

import {
  onAddNewLocation,
  onRemoveLocation,
  onUpdateLocation,
  getEpikBoxData,
} from '../actions/EpikBoxes';
import ModelAutoComplete from './ModelAutoComplete';
import SerialNumberSelect from './SerialNumberSelect';
import { MODEL_LIST, MODEM_LIST } from '../lib/constants';
import {
  addBulkBoxSession,
  disableBulkBoxSession,
  enableBulkBoxSession,
} from '../actions/BoxSessionLogging';
import OptionalDropdownSelect from './OptionalDropdownSelect';

class NewEpikbox extends Component {
  constructor(props) {
    super(props);
    this.state = {
      displayName: '',
      serialNumber: '',
      customerProvidedIp: '',
      lteIp: '',
      lteIp2: '',
      wgPublicKey: '',
      model: '',
      city: '',
      state: '',
      address: '',
      zip: '',
      assignedTo: '',
      numModems: 0,
      numberOfModems: 0,
      imei: [],
      imsi: [],
      modemPhone: [],
      apn: [],
      apuType: '',
      notifyEmails: [],
      emergencyNumbers: [],
      emergencyEmails: [],
      notifyNumbers: [],
      locRef: '',
      onSerialNumberSelect: false,
      _id: '',
      staticEmails: [],
      shipment: '',
      alertCompanyMails: false,
      modems: [{ imeis: '', label: '', phones: [], sims: [], type: '' }],
      newBox: true,
    };
  }

  componentDidUpdate(prevProps, prevState) {
    const { importObj, companies, getLocationByCompany, selectedBox } = this.props;
    if (
      Object.keys(importObj).length &&
      Object.keys(importObj).length !== Object.keys(prevProps.importObj).length
    ) {
      if (companies) {
        var unassigned = companies.docs.find(el => el.name === importObj.unassignedCompanyName);
        getLocationByCompany(unassigned._id);
        this.setState(
          {
            assignedTo: unassigned._id,
          },
          () => {
            this.props.onFormDataChange({ ...this.state });
          },
        );
      }

      const {
        displayName,
        serialNumber,
        model,
        imei,
        imsi,
        modemPhone,
        apn,
        notifyEmails,
        emergencyNumbers,
        emergencyEmails,
        notifyNumbers,
        assignedCompany,
        city,
        state,
        zip,
        vpnAddress,
        locRef,
        Obis,
        companyName,
        customerProvidedIp,
        lteIp,
        wgPublicKey,
        shipment,
        alertCompanyMails,
        modems,
      } = this.props.importObj || selectedBox;
      this.setState({
        displayName: displayName || '',
        serialNumber: serialNumber || '',
        customerProvidedIp: customerProvidedIp || '',
        lteIp: lteIp || '',
        wgPublicKey: wgPublicKey || '',
        model: model || '',
        numModems: imei.length,
        modems: modems || [],
        numberOfModems: modems.length,
        imei: imei || [],
        imsi: imsi || [],
        modemPhone: modemPhone || [],
        apn: apn || [],
        notifyEmails: notifyEmails || [],
        notifyNumbers: notifyNumbers || [],
        emergencyNumbers: emergencyNumbers || [],
        emergencyEmails: emergencyEmails || [],
        city: city || '',
        state: state || '',
        vpnAddress: vpnAddress || '',
        zip: zip || '',
        locRef: locRef || '',
        Obis: Obis || [],
        companyName: companyName || '',
        shipment: shipment || '',
        alertCompanyMails: alertCompanyMails || false,
      });
      this.props.onFormDataChange({
        displayName: displayName || '',
        serialNumber: serialNumber || '',
        customerProvidedIp: customerProvidedIp || '',
        lteIp: lteIp || '',
        wgPublicKey: wgPublicKey || '',
        model: model || '',
        numModems: imei.length,
        modems: modems || [],
        numberOfModems: modems.length,
        imei: imei || [],
        imsi: imsi || [],
        modemPhone: modemPhone || [],
        apn: apn || [],
        notifyEmails: notifyEmails || [],
        notifyNumbers: notifyNumbers || [],
        emergencyNumbers: emergencyNumbers || [],
        emergencyEmails: emergencyEmails || [],
        city: city || '',
        state: state || '',
        vpnAddress: vpnAddress || '',
        zip: zip || '',
        locRef: locRef || '',
        Obis: Obis || [],
        companyName: companyName || '',
        shipment: shipment || '',
        alertCompanyMails: alertCompanyMails || false,
      });
    }
  }

  trasnformStateToBox = () => {
    const {
      displayName,
      serialNumber,
      model,
      locRef,
      assignedTo,
      numModems,
      numberOfModems,
      imei,
      imsi,
      modemPhone,
      apn,
      notifyEmails,
      notifyNumbers,
      emergencyNumbers,
      emergencyEmails,
      customerProvidedIp,
      lteIp,
      wgPublicKey,
      shipment,
      alertCompanyMails,
      modems,
    } = this.state;

    return {
      displayName,
      serialNumber,
      model,
      customerProvidedIp,
      lteIp,
      wgPublicKey,
      locRef,
      assignedTo,
      numModems,
      numberOfModems,
      imei: imei.slice(0, numModems),
      imsi: imsi.slice(0, numModems),
      modemPhone: modemPhone.slice(0, numModems),
      apn: apn.slice(0, numModems),
      notifyEmails,
      notifyNumbers,
      emergencyNumbers,
      emergencyEmails,
      shipment,
      alertCompanyMails,
      modems,
    };
  };

  handleNumModems = e => {
    const { modems } = this.state;
    const modemObj = { imeis: '', label: '', phones: [], sims: [], type: '' };
    let updatedModems = [...modems];
    if (e === 'add') {
      // concat modemObj to updatedModems array
      updatedModems = updatedModems.concat(modemObj);
      this.setState(
        { numberOfModems: this.state.numberOfModems + 1, modems: updatedModems },
        () => {
          this.props.onFormDataChange(this.trasnformStateToBox());
        },
      );
    } else {
      if (this.state.numberOfModems !== 0) {
        // remove last object from updatedModems array
        updatedModems.pop();

        this.setState(
          { numberOfModems: this.state.numberOfModems - 1, modems: updatedModems },
          () => {
            this.props.onFormDataChange(this.trasnformStateToBox());
          },
        );
      }
    }
  };
  onFormFieldChange = ev => {
    const { name, value } = ev.target;
    if (name === 'displayName') {
      this.props.addBulkBoxSession(`Added Display Name - ${value}`, 'displayname');
    }
    if (name === 'serialNumber') {
      this.props.addBulkBoxSession(`Added Serial Number - ${value}`, 'serialNumber');
    }
    if (name === 'customerProvidedIp') {
      this.props.addBulkBoxSession(`Added customer Provided Ip - ${value}`, 'customerProvidedIp');
    }
    if (name === 'lteIp') {
      this.props.addBulkBoxSession(`Added LTE IP - ${value}`, 'lteIp');
    }
    if (name === 'wgPublicKey') {
      this.props.addBulkBoxSession(`Added Wg Public Key - ${value}`, 'wgPublicKey');
    }
    if (name === 'shipment') {
      this.props.addBulkBoxSession(`Added shipment - ${value}`, 'shipment');
    }
    this.setState(
      {
        [name]: value,
      },
      () => {
        this.props.onFormDataChange(this.trasnformStateToBox());
      },
    );
  };

  onModelFilter = e => {
    this.props.addBulkBoxSession(`Added Edge Device Model - ${e?.value}`, 'edgedevice');
    const { name, value } = e;
    this.setState(
      {
        model: value,
      },
      () => {
        this.props.onFormDataChange(this.trasnformStateToBox());
      },
    );
  };

  onCompanyChange = ({ name, value, suggestion }) => {
    if (suggestion !== null) {
      this.props.addBulkBoxSession(`Added company name - ${suggestion?.name}`, 'companyName');
      this.props.getLocationByCompany(suggestion._id);
      this.setState(
        {
          assignedTo: suggestion._id,
          accountNumber: suggestion.epikCustomerId,
          staticEmails: suggestion.contactEmails,
          companyName: suggestion.name
        },
        () => {
          this.props.onFormDataChange({ ...this.state });
        },
      );
    }
  };
  onSerialNumberChange = async ({ name, value, suggestion }) => {
    if (suggestion != null) {
      const selected = await this.props.getEpikBoxData(
        localStorage.getItem('jwtToken'),
        suggestion._id,
      );
      this.setState(
        {
          displayName: selected.displayName || '',
          serialNumber: selected.serialNumber || '',
          customerProvidedIp: selected.customerProvidedIp || '',
          lteIp: selected.lteIp || '',
          wgPublicKey: selected.wgPublicKey || '',
          model: selected.model || '',
          numModems: selected.imei.length,
          numberOfModems: selected.modems.length,
          imei: selected.imei || [],
          imsi: selected.imsi || [],
          modemPhone: selected.modemPhone || [],
          apn: selected.apn || [],
          notifyEmails: selected.notifyEmails || [],
          notifyNumbers: selected.notifyNumbers || [],
          emergencyNumbers: selected.emergencyNumbers || [],
          emergencyEmails: selected.emergencyEmails || [],
          city: selected.city || '',
          state: selected.state || '',
          vpnAddress: selected.vpnAddress || '',
          zip: selected.zip || '',
          locRef: selected.locRef || '',
          Obis: selected.Obis || [],
          companyName: selected.companyName || '',
          _id: selected._id || '',
          // assignedTo: selected.assignedTo || '',
          onSerialNumberSelect: true,
          shipment: selected.shipment || '',
          alertCompanyMails: selected.alertCompanyMails,
        },
        () => {
          this.props.onFormDataChange({ ...this.state });
          this.props.getLocationByCompany(selected.assignedTo._id);
          this.props.onSerialNumberSelect(this.state.onSerialNumberSelect);
        },
      );
    }
  };
  onTypeTextChange = e => {
    const target = {
      name: 'serialNumber',
      value: e,
    };
    this.onFormFieldChange({ target });
  };

  onAPNChange(apnIndex, ev) {
    this.props.addBulkBoxSession('Added APN - ', `apn${apnIndex + 1}`);
    const { value } = ev.target;
    const apn = [...this.state.apn];
    apn[apnIndex] = value;
    this.setState({ apn }, () => {
      this.props.onFormDataChange({ ...this.state });
    });
  }

  onEmailsChange(emails) {
    this.props.addBulkBoxSession(`Added Email Address - ${emails}`, 'emailNotification');
    const target = {
      name: 'notifyEmails',
      value: emails,
    };
    this.onFormFieldChange({ target });
  }
  onEmergencyEmailsChange(emails) {
    this.props.addBulkBoxSession(
      `Added Emergency Email Address - ${emails}`,
      'emergencyEmailNotification',
    );
    const target = {
      name: 'emergencyEmails',
      value: emails,
    };
    this.onFormFieldChange({ target });
  }

  selectLocation = e => {
    if (!this.state.onSerialNumberSelect) {
      const target = {
        name: 'locRef',
        value: e._id,
      };
      this.onFormFieldChange({ target });
    }
  };
  selectedLocationObj = e => {
    this.props.addBulkBoxSession(`Added New Location -  ${e.locationName}`, 'newLocation');
    if (this.state.onSerialNumberSelect) {
      this.setState(
        {
          locRef: e,
        },
        () => {
          this.props.onFormDataChange({ ...this.state });
        },
      );
    }
  };

  onNumberssChange(numbers) {
    this.props.addBulkBoxSession(`Added Notification Number - ${numbers}`, 'notificationNumber');
    const target = {
      name: 'notifyNumbers',
      value: numbers,
    };
    this.onFormFieldChange({ target });
  }
  onEmergencyNumberssChange(numbers) {
    this.props.addBulkBoxSession(`Added Emergency Number - ${numbers}`, 'emergencyNumber');
    const target = {
      name: 'emergencyNumbers',
      value: numbers,
    };
    this.onFormFieldChange({ target });
  }

  handleFocus = ev => {
    ev.target.select();
  };

  onFormItemChange = (ev, imeiIndex) => {
    const { value, name } = !!ev.name ? ev : ev.target;
    const { addBulkBoxSession } = this.props;
    addBulkBoxSession(`Added ${name} - `, `${name}${imeiIndex + 1}`);
    const modems = [...this.state.modems];
    const inputName = name === 'sim1' || name === 'sim2' ? 'sims' : name;
    const replace = ['phones', 'sim1', 'sim2'].some(x => x === name);
    const simIndex = name === 'phones' || name === 'sim1' ? 0 : 1;
    replace ? (modems[imeiIndex][inputName][simIndex] = value) : (modems[imeiIndex][name] = value);
    if (modems[0].sims[1]) {
      this.setState({ modems }, () => {
        this.props.onFormDataChange({ ...this.state });
      });
    } else {
      this.setState({ modems, lteIp2: '' }, () => {
        this.props.onFormDataChange({ ...this.state });
      });
    }
  };

  renderImeiImzi = () => {
    const { modems } = this.state;
    const initialModem = modems[0];
    const view = [];
    const imei = initialModem.imeis;
    const modemPhone = initialModem.phones[0];
    const modemSim1 = initialModem?.sims[0];
    const modemSim2 = initialModem?.sims[1];
    view.push(
      <>
        <h1 className="modem-number">Modem</h1>
        <div className="modem-container" key={`imeiimsi${0}`}>
          <Row>
            <Col md={4} sm={12}>
              <FormGroup row>
                <Label for={`imei${0}`} sm={6}>
                  Modem Type
                </Label>
                <Col sm={12}>
                  <OptionalDropdownSelect
                    placeholder="Filter Model"
                    nameTag="type"
                    filterTag="name"
                    dropdownList={MODEM_LIST}
                    onChange={e => this.onFormItemChange(e, 0)}
                  />
                </Col>
              </FormGroup>
            </Col>
            <Col md={4} sm={12}>
              <FormGroup row>
                <Label for={`imei${0}`} sm={6}>
                  IMEI
                </Label>
                <Col sm={12}>
                  <Input
                    required
                    type="text"
                    name={`imeis`}
                    value={imei}
                    onChange={ev => this.onFormItemChange(ev, 0)}
                  />
                </Col>
              </FormGroup>
            </Col>
            <Col md={4} sm={12}>
              <FormGroup row>
                <Label for={`modemPhone${0}`} sm={6}>
                  Phone
                </Label>
                <Col sm={12}>
                  <Input
                    required
                    type="text"
                    name={`phones`}
                    value={modemPhone}
                    onChange={ev => this.onFormItemChange(ev, 0)}
                  />
                </Col>
              </FormGroup>
            </Col>
          </Row>
          <Row>
            <Col md={6} sm={12}>
              <FormGroup row>
                <Label for={`sim1`} sm={6}>
                  SIM 1
                </Label>
                <Col sm={12}>
                  <Input
                    required
                    type="text"
                    name={`sim1`}
                    value={modemSim1 || ''}
                    placeholder="Set box Phone"
                    onFocus={this.handleFocus}
                    onChange={e => this.onFormItemChange(e, 0)}
                  />
                </Col>
              </FormGroup>
            </Col>
            <Col md={6} sm={12}>
              <FormGroup row>
                <Label for={`sim${2}`} sm={6}>
                  SIM 2
                </Label>
                <Col sm={12}>
                  <Input
                    required
                    type="text"
                    name={`sim2`}
                    value={modemSim2 || ''}
                    placeholder="Set box Phone"
                    onFocus={this.handleFocus}
                    onChange={e => this.onFormItemChange(e, 0)}
                  />
                </Col>
              </FormGroup>
            </Col>
          </Row>
        </div>
      </>,
    );
    return view;
  };

  createNewLocation = async ev => {
    const { assignedTo } = this.state;
    const { onAddNewLocation, getLocationByCompany } = this.props;
    let res = await onAddNewLocation(localStorage.getItem('jwtToken'), assignedTo, ev);
    if (res) {
      await getLocationByCompany(assignedTo);
    }
  };

  updateLocation = async ev => {
    const { assignedTo } = this.state;
    const { onUpdateLocation, getLocationByCompany } = this.props;
    let res = await onUpdateLocation(localStorage.getItem('jwtToken'), assignedTo, ev);
    if (res) {
      await getLocationByCompany(assignedTo);
    }
  };

  onRemoveLocation = async ev => {
    const { assignedTo } = this.state;
    const { onRemoveLocation, getLocationByCompany } = this.props;
    let res = await onRemoveLocation(localStorage.getItem('jwtToken'), ev);
    if (res) {
      await getLocationByCompany(assignedTo);
    }
  };

  onChangeShowAlertContacts = value => {
    if (!value) {
      this.props.enableBulkBoxSession(
        'Show contacts changed from disabled to enabled',
        'alertContacts',
      );
    } else {
      this.props.disableBulkBoxSession(
        'Show contacts changed from enabled to  disabled',
        'alertConatcts',
      );
    }
    const target = {
      name: 'alertCompanyMails',
      value: !value,
    };
    this.onFormFieldChange({ target });
  };

  render() {
    const { locations, unassignedBoxes, selectedBox } = this.props;
    const { accountNumber, alertCompanyMails, staticEmails } = this.state;
    return (
      <div className="container">
        <Row>
          <Col md={4} sm={12}>
            <FormGroup row>
              <Label for="model" sm={8}>
                Display Name:
              </Label>
              <Col sm={12}>
                <Input
                  required
                  placeholder="Enter name"
                  type="text"
                  name="displayName"
                  value={this.state.displayName}
                  onChange={this.onFormFieldChange}
                />
              </Col>
            </FormGroup>
          </Col>
          <Col md={4} sm={12}>
            <FormGroup row>
              <Label for="model" sm={8}>
                Serial Number:
              </Label>
              <Col sm={12}>
                <SerialNumberSelect
                  typeTextChange={this.onTypeTextChange}
                  isDisabled={this.props.disableCompany}
                  searchTerm={
                    this.props.disableCompany ? this.props.importObj.unassignedCompanyName : ''
                  }
                  placeholder="Choose one or type serial number"
                  companies={unassignedBoxes}
                  onChange={this.onSerialNumberChange}
                />
              </Col>
            </FormGroup>
          </Col>
        </Row>

        <Row>
          <Col md={3} sm={12}>
            <FormGroup row>
              <Label for="customerProvidedIp" sm={12}>
                Static IP Address
              </Label>
              <Col sm={12}>
                <Input
                  required
                  placeholder="Please specify"
                  type="text"
                  name="customerProvidedIp"
                  value={this.state.customerProvidedIp}
                  onChange={this.onFormFieldChange}
                />
              </Col>
            </FormGroup>
          </Col>
          <Col md={4} sm={12}>
            <FormGroup row>
              <Label for="lteIp" sm={6}>
                LTE IP
              </Label>
              <Col sm={12}>
                <Input
                  required
                  placeholder="Please specify"
                  type="text"
                  name="lteIp"
                  value={this.state.lteIp}
                  onChange={this.onFormFieldChange}
                />
              </Col>
            </FormGroup>
          </Col>
          <Col md={3} sm={12}>
            <FormGroup row>
              <Label for="wgPublicKey" sm={12}>
                WG Public Key
              </Label>
              <Col sm={12}>
                <Input
                  required
                  placeholder="Please specify"
                  type="text"
                  name="wgPublicKey"
                  value={this.state.wgPublicKey}
                  onChange={this.onFormFieldChange}
                />
              </Col>
            </FormGroup>
          </Col>
        </Row>

        <Row>
          <Col md={3} sm={12}>
            <FormGroup row>
              <Label for="model" sm={8}>
                Edge Device Model:
              </Label>
              <Col sm={12}>
                <ModelAutoComplete
                  placeholder="Filter Model"
                  models={MODEL_LIST}
                  onChange={this.onModelFilter}
                />
              </Col>
            </FormGroup>
          </Col>
          <FormGroup>
            <Label for="model" sm={8}>
              APU Type:
            </Label>
            <Col sm={12}>
              <Input
                required
                placeholder="Please specify"
                type="text"
                name="apuType"
                value={this.state.apuType}
                onChange={this.onFormFieldChange}
              />
            </Col>
          </FormGroup>
          {this.state.modems[0].sims[1] && (
            <FormGroup>
              <Label for="model" sm={8}>
                LTE IP 2:
              </Label>
              <Col sm={12}>
                <Input
                  required
                  placeholder="Please specify"
                  type="text"
                  name="lteIp2"
                  value={this.state.lteIp2}
                  onChange={this.onFormFieldChange}
                />
              </Col>
            </FormGroup>
          )}
        </Row>
        <Row className="modems-container">
          <Col md={12} lg={12} xs={12} sm={12}>
            <hr />
            <h1 className="modem-text">Modem Management</h1>
          </Col>
          {/* commenting this on purpose */}
          {/* <Col md={2} sm={12}>
            <FormGroup row>
              <Label for="numberOfModems" sm={12}>
                Total Modems:
              </Label>
              <Col sm={12} className="totalModemInput">
                <InputGroupAddon addonType="prepend" onClick={() => this.handleNumModems('add')}>
                  <InputGroupText>
                    <img className="modemAdd-icon" src={plus} alt="add" />
                  </InputGroupText>
                </InputGroupAddon>
                <Input
                  autoComplete="off"
                  required
                  placeholder="0"
                  type="number"
                  min="0"
                  max="2"
                  name="numberOfModems"
                  value={this.state.numberOfModems}
                  onChange={this.onFormFieldChange}
                />
                <InputGroupAddon addonType="append" onClick={() => this.handleNumModems('sub')}>
                  <InputGroupText>
                    <img className="modemAdd-icon" src={minus} alt="remove" />
                  </InputGroupText>
                </InputGroupAddon>
              </Col>
            </FormGroup>
          </Col> */}
          <Col>{this.renderImeiImzi()}</Col>
        </Row>
        <hr />

        <Row>
          <Col md={4} sm={12}>
            <FormGroup row>
              <Label for="assignedTo" sm={6}>
                Account Number:
              </Label>
              <Col sm={12}>
                <Input
                  required
                  placeholder="Not specified"
                  type="text"
                  disabled
                  value={accountNumber}
                  onChange={this.onFormFieldChange}
                />
              </Col>
            </FormGroup>
          </Col>
        </Row>
        <Row>
          <Col md={3} sm={12}>
            <FormGroup row>
              <Label for="assignedTo" sm={6}>
                Company:
              </Label>
              <Col sm={12}>
                <CompanyAutocomplete
                  isDisabled={this.props.disableCompany}
                  searchTerm={
                    this.props.disableCompany ? this.props.importObj.unassignedCompanyName : ''
                  }
                  placeholder="Choose one"
                  companies={this.props.companies.docs}
                  onChange={this.onCompanyChange}
                />
              </Col>
            </FormGroup>
          </Col>

          {this.state.assignedTo !== '' && (
            <Col md={4} sm={12}>
              <FormGroup row>
                <Label for="address" sm={6}>
                  Location:
                </Label>
                <Col sm={12}>
                  <LocationDetails
                    selectedLocationObj={this.selectedLocationObj}
                    selectLocation={this.selectLocation}
                    locations={locations}
                    onRemoveLocation={this.onRemoveLocation}
                    createNewLocation={this.createNewLocation}
                    updateLocation={this.updateLocation}
                  />
                </Col>
              </FormGroup>
            </Col>
          )}
        </Row>
        <Row>
          <Col md={6} sm={12}>
            <FormGroup row>
              <Label for="emails" sm={6}>
                Notification email(s):
              </Label>
              <Col sm={8}>
                <MultiInput
                  placeholder="Enter the email"
                  inputData={this.state.notifyEmails}
                  onChange={this.onEmailsChange.bind(this)}
                  validator={util.validateEmail}
                  staticEmails={this.state.staticEmails}
                />
              </Col>
            </FormGroup>
          </Col>
          <Col md={6} sm={12}>
            <FormGroup row>
              <Label for="numbers" sm={6}>
                Notification number(s):
              </Label>
              <Col sm={8}>
                <MultiInput
                  placeholder="Enter the number"
                  inputData={this.state.notifyNumbers}
                  onChange={this.onNumberssChange.bind(this)}
                />
              </Col>
            </FormGroup>
          </Col>
          {staticEmails && staticEmails.length > 0 && (
            <Col md={6} sm={12}>
              <div className="d-flex">
                <Label for="AlertContacts" sm={4} className="px-0">
                  Show Alert Contacts:
                </Label>
                <Col sm={4} style={{ padding: '5px' }}>
                  <Toggle value={alertCompanyMails} onToggle={this.onChangeShowAlertContacts} />
                </Col>
              </div>
              <Col sm={8}>
                {alertCompanyMails &&
                  staticEmails.map(item => (
                    <div className="multi-input-item" key={item}>
                      <span className="item">{item}</span>
                    </div>
                  ))}
              </Col>
            </Col>
          )}
          <Col md={12} sm={12}>
            <hr />
          </Col>
          <Col md={4} sm={12}>
            <FormGroup row>
              <Label for="shipment" sm={8}>
                Shipping :
              </Label>
              <Col sm={12}>
                <Input
                  required
                  placeholder="Please Specify"
                  type="text"
                  name="shipment"
                  value={this.state.shipment}
                  onChange={this.onFormFieldChange}
                />
              </Col>
            </FormGroup>
          </Col>
        </Row>
        <Row>
          <Col md={6} sm={12}>
            <FormGroup row>
              <Label for="emails" sm={6}>
                911 Notification Alert Email:
              </Label>
              <Col sm={8}>
                <MultiInput
                  placeholder="Enter the email"
                  inputData={this.state.emergencyEmails}
                  onChange={this.onEmergencyEmailsChange.bind(this)}
                  validator={util.validateEmail}
                  staticEmails={this.state.staticEmails}
                />
              </Col>
            </FormGroup>
          </Col>
          <Col md={6} sm={12}>
            <FormGroup row>
              <Label for="numbers" sm={6}>
                911 Notification Alert SMS Text Number(s):
              </Label>
              <Col sm={8}>
                <MultiInput
                  placeholder="Enter the number"
                  inputData={this.state.emergencyNumbers}
                  onChange={this.onEmergencyNumberssChange.bind(this)}
                />
              </Col>
            </FormGroup>
          </Col>
        </Row>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  selectedBox: state.AppState.boxDetails.box,
});

const mapDispatchToProps = dispatch => ({
  onAddNewLocation: (token, cid, obj) => dispatch(onAddNewLocation(token, cid, obj)),
  onUpdateLocation: (token, cid, obj) => dispatch(onUpdateLocation(token, cid, obj)),
  onRemoveLocation: (token, id) => dispatch(onRemoveLocation(token, id)),
  getEpikBoxData: (token, boxId) => dispatch(getEpikBoxData(token, boxId)),
  addBulkBoxSession: (description, key) => dispatch(addBulkBoxSession(description, key)),
  disableBulkBoxSession: (description, key) => dispatch(disableBulkBoxSession(description, key)),
  enableBulkBoxSession: (description, key) => dispatch(enableBulkBoxSession(description, key)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(NewEpikbox);
